<template>
	<div class="time-sel" ref="timePage" v-show="showTimePage" @touchmove="touchmove">
		<div class="body" ref="body" :class="{ add: dataLength > 15, special: !noSpecial }" @touchmove="touchmove">
			<div class="main" @touchmove="touchmove">
				<div class="title" @touchmove="touchmove">
					选择到场时间
					<div class="close" @click="close">
						<img src="../../assets/images/close.png" alt="" />
					</div>
				</div>
				<div class="time-group" v-if="dataLength < 15" @touchmove="touchmove">
					<div
						@touchmove="touchmove"
						class="time-block"
						v-for="item in monthData"
						:key="item.id"
						:class="{
							active: timeObj.id == item.id,
							disabled: item.currentVolume >= item.capacity || item.isExpired,
						}"
						@click="dateSel(item)"
					>
						<span class="time-block-span" @touchmove="touchmove">
							{{ item.month }}/{{ item.date }} 周{{ item.week
							}}<span class="xing">{{ item.special ? '*' : '' }}</span>
						</span>
					</div>
				</div>

				<div class="time-group time-month" v-else @touchmove="touchmove">
					<div class="month-names" @touchmove="touchmove">
						<div
							class="month-name"
							v-for="item in monthNames"
							:key="item"
							@click="switchMonth(item)"
							@touchmove="touchmove"
						>
							<span
								@touchmove="touchmove"
								class="name"
								:class="{ active: item == currentMonth, isAndroid: !isIos }"
								>{{ item }}月</span
							>
						</div>
					</div>

					<div class="line week-name" @touchmove="touchmove">
						<div class="box" v-for="item in weekName" :key="item" @touchmove="touchmove">
							{{ item }}
						</div>
					</div>
					<!-- 月份 -->
					<div class="line line-day-box" @touchmove="touchmove">
						<div
							@touchmove="touchmove"
							class="box day-number"
							:class="{
								active: selDateObj.id == item.id,
								disabled: !item.sceneId || item.currentVolume >= item.capacity || item.isExpired,
								hidden: !item.bookingDate,
							}"
							v-for="item in forData"
							:key="item.id"
							@click="dateSel(item)"
						>
							<span class="number"
								>{{ item.date == 0 ? '' : item.date }}
								<span class="xing">{{ item.special ? '*' : '' }}</span>
							</span>
						</div>
					</div>
				</div>
				<div class="divide-line" v-show="!noSpecial" @touchmove="touchmove"></div>
				<div class="info" @touchmove="touchmove" v-show="!noSpecial">
					<div class="btns" v-if="hasSpecial" @touchmove="touchmove">
						<div
							@touchmove="touchmove"
							class="btn"
							:class="{
								active: item.id == bookingSpecialServeId,
								disabled: item.currentVolume >= item.capacity,
							}"
							v-for="item in dayScenes"
							:key="item.id"
							@click="_btnSel(item)"
						>
							{{
								item.currentVolume >= item.capacity
									? '彩妆秀 ' + item.specialTime.slice(0, 2) + ':00 已满'
									: '预约彩妆秀 ' + item.specialTime.slice(0, 2) + ':00'
							}}
						</div>
					</div>
					<div class="text" v-else @touchmove="touchmove">
						*部分场次设立彩妆秀活动，香奈儿彩妆师将为你现场演绎最新灵感妆容。
					</div>
				</div>
			</div>
			<div class="button disabled" v-if="btnDisabled" @touchmove="touchmove">
				确认
			</div>
			<div v-else class="button" @click="confirm" @touchmove="touchmove">
				确认
			</div>
		</div>
	</div>
</template>
<script>
import { Utils } from '@/assets/js/utils'
import moment from 'moment'
export default {
	props: {
		showTimePage: {
			type: Boolean,
			default: false,
		},
		dateArray: {
			type: Object,
			default: function() {},
		},
		channel: {
			type: String,
			default: '',
		},
	},

	data() {
		return {
			timeObj: {},
			weekName: ['日', '一', '二', '三', '四', '五', '六'],
			monthNames: [4, 5],
			currentMonth: 4,
			monthData: [], // 两周之内的数据
			selDateObj: {},
			btnDisabled: true,
			dateData: null,
			dataLength: 0,
			timeGraphId: [],
			dayScenes: [],
			hasSpecial: false,
			bookingSpecialServeId: -1,
			bookingSpecialServe: {},
			monthItemData: {},
			forData: [],
			noSpecial: true,
			alreadyFull: false,
		}
	},
	mounted() {
		this.dateObj = this.dateArray
		setTimeout(() => {
			Utils.scrollFix(this.$refs.timePage)
		}, 400)
		this.initData(this.dateObj)
		this.isIos = Utils.isIos()
	},
	methods: {
		initData(dateObj) {
			this.dateObj = dateObj
			const { specialServe, bookingTime } = dateObj
			let timeGraphId = []
			for (let i in specialServe) {
				let id = specialServe[i].bookingTimeId
				if (timeGraphId.indexOf(id) == -1 && specialServe[i].channel == this.channel) {
					timeGraphId.push(id)
				}
			}
			this.timeGraphId = timeGraphId
			this.dataLength = Object.keys(bookingTime).length
			console.log(this.dataLength)
			this.currentMonth = this.monthNames[0]
			this.getMonthData()
		},
		touchmove(e) {
			if (this.showTimePage) {
				let bodyHeight = document.body.clientHeight || document.documentElement.clientHeight
				let bodyDivHeight = this.$refs.body.clientHeight + 64
				if (bodyHeight >= bodyDivHeight) {
					e.preventDefault()
				}
			}
		},
		random() {
			return Math.random()
		},
		close() {
			// this.selDateObj = {}
			// this.btnDisabled = true
			this.$emit('update:showTimePage', false)
		},
		confirm() {
			this.$emit('timeSel', {
				dateData: this.dateData,
				bookingSpecialServe: this.bookingSpecialServe,
			})
			this.close()
		},
		getMonthData() {
			const monthData = []
			const { bookingTime } = this.dateObj
			let monthNames = []
			let _monthNames = [] // 存放具体年份的日期
			let monthItemData = {}
			let year = 0
			let month = 0
			let date = 0
			for (let i in bookingTime) {
				year = bookingTime[i].bookingDate.slice(0, 4)
				// console.log(year)
				month = bookingTime[i].bookingDate.slice(4, 6)
				date = bookingTime[i].bookingDate.slice(6, 8)
				let yearItem = Number(year)
				let monthItem = Number(month)
				let dateItem = Number(date)
				let isExist = _monthNames.find((item) => {
					return item.month === monthItem
				})
				if (!isExist) {
					// 增加精确月份，方便日期跨年排序
					_monthNames.push({
						month: monthItem,
						bookingDate: bookingTime[i].bookingDate,
					})
					monthItemData[monthItem] = []
				}
				// let day = moment().get('year') + '-' + month + '-' + date
				let day = yearItem + '-' + month + '-' + date
				// console.log('day', day)
				let weekDay = Number(moment(day).format('d'))
				// console.log('weekDay', weekDay)
				const dayData = {
					...bookingTime[i],
					// wholeDate: moment().get('year') + '-' + month + '-' + date,
					wholeDate: yearItem + '-' + month + '-' + date,
					month: monthItem,
					date: dateItem,
					week: Utils.getWeekName(weekDay % 7),
					special: this.timeGraphId.indexOf(bookingTime[i].id) > -1 ? true : false,
				}
				monthData.push(dayData)
				monthItemData[monthItem].push(dayData)
			}
			console.log('_monthNames', _monthNames)
			console.log(monthItemData)
			// 根据年份日期排序
			_monthNames.sort((a, b) => a.bookingDate - b.bookingDate)
			console.log('_monthNames sort', _monthNames)
			if (_monthNames.length > 0) {
				monthNames = []
				_monthNames.forEach((item) => {
					monthNames.push(item.month)
				})
			}

			// monthNames.sort((a, b) => a - b)
			this.monthNames = monthNames
			this.currentMonth = monthNames[0]
			Object.keys(monthItemData).forEach((item) => {
				monthItemData[item] = monthItemData[item].sort((a, b) => a.date - b.date)
			})
			// console.log(monthItemData)
			this.monthItemData = monthItemData
			monthData.sort((a, b) => a.bookingDate - b.bookingDate)
			this.monthData = monthData
			// console.log(this.monthData)

			let noSpecial = true
			let isFull = true
			monthData.forEach((item) => {
				if (item.special) {
					noSpecial = false
				}
				if (item.currentVolume < item.capacity) {
					isFull = false
				}
			})
			if (isFull) {
				this.$router.replace('/full')
				return
			}
			this.noSpecial = noSpecial
			if (Object.keys(bookingTime).length > 14) {
				this.switchMonth(this.currentMonth)
			}
		},
		switchMonth(month) {
			this.currentMonth = month
			this.bookingSpecialServeId = -1
			this.hasSpecial = false
			if (this.selDateObj.month) {
				this.btnDisabled = false
			} else {
				this.btnDisabled = true
			}
			let monthDataPre = JSON.parse(JSON.stringify(this.monthItemData[month]))
			let monthDatas = JSON.parse(JSON.stringify(this.monthItemData[month]))

			let initMonth = moment(monthDatas[0].wholeDate)
				.set('month', this.currentMonth - 1)
				.set('date', 1)
			let daysLen = moment(initMonth).daysInMonth()
			let weekDay = Number(moment(initMonth).format('d'))
			if (monthDataPre[0].date !== 1) {
				for (let i = monthDataPre[0].date - 1; i > 0; i--) {
					monthDatas.unshift({
						id: this.random(),
						month,
						date: i,
					})
				}
			}
			for (let i = 0; i < weekDay; i++) {
				monthDatas.unshift({
					id: this.random(),
					date: 0,
				})
			}
			for (let i = monthDataPre[monthDataPre.length - 1].date + 1; i < daysLen; i++) {
				monthDatas.push({
					id: this.random(),
					month,
					date: i,
				})
			}
			this.forData = monthDatas
			let noSpecial = true
			monthDatas.forEach((item) => {
				if (item.special) {
					noSpecial = false
				}
			})
			this.noSpecial = noSpecial
		},
		dateSel(dayItem) {
			this.bookingSpecialServeId = -1
			this.bookingSpecialServe = {}
			this.timeObj = dayItem
			this.selDateObj = dayItem
			this.dateData = dayItem
			this.btnDisabled = false
			this.hasSpecial = dayItem.special
			const { specialServe } = this.dateObj
			let dayScenes = []
			for (let i in specialServe) {
				if (specialServe[i].bookingTimeId == dayItem.id && specialServe[i].channel == this.channel) {
					dayScenes.push(specialServe[i])
				}
			}
			dayScenes.sort((a, b) => a.specialTime - b.specialTime)
			this.dayScenes = dayScenes
		},
		_btnSel(obj) {
			if (obj.id == this.bookingSpecialServeId) {
				this.bookingSpecialServe = {}
				this.bookingSpecialServeId = -1
			} else {
				this.bookingSpecialServe = obj
				this.bookingSpecialServeId = obj.id
			}
		},
	},
}
</script>
<style lang="stylus" scoped>
.time-sel
  position fixed
  top 0
  left 0
  right 0
  bottom 0
  overflow auto
  height 100%
  background #ffffff
  z-index 100
  padding 32px 0
  box-sizing border-box
  margin 0 auto
  padding-bottom: 31px
  &.pageDisabled
    overflow hidden
  .body
    width 100%
    height 100%
    display flex
    flex-direction column
    justify-content space-between
    &.add
      &.special
        min-height 577px
  .title
    font-size 14px
    line-height 14px
    text-align center
    position relative
    width 327px
    margin 0 auto
    .close
      position absolute
      right -1px
      top 0
      width 14px
      z-index 100
      img
        max-width 100%
  .divide-line
    width 100%
    height 1px
    background #eaeaea
  .info
    width 327px
    margin 0 auto
    font-size 12px
    line-height 18px
    color #9d9d9d
    .text
      margin-top 21px
      margin-bottom 53px
    .btns
      margin-top 24px
      margin-bottom 46px
      display flex
      justify-content space-between
      .btn
        // flex 0 0 154px
        width 154px
        height 40px
        border 1px solid #999999
        font-size 14px
        display flex
        justify-content center
        align-items center
        box-sizing border-box
        color #000000
        &.disabled
          background #f3f3f3
          border-color #E6E6E6
          color #9D9D9D
          pointer-events none
        &.active
          border 2px solid #000000
          // font-weight bold
          font-family PingFangSC-Medium, 'PingFangH'
  .time-group
    width 345px
    margin 24px auto
    overflow hidden
    .time-block
      width 97px
      height 40px
      display flex
      justify-content center
      align-items center
      border 1px solid #999
      font-size 14px
      margin 8px 9px
      box-sizing border-box
      float left
      .time-block-span
        position relative
        .xing
          position absolute
          right -6px
          top 0
          font-size 12px
      &.active
        border 2px solid #000000
        font-family PingFangSC-Medium, 'PingFangH'
      &.disabled
        background #f3f3f3
        border 1px solid #e6e6e6
        pointer-events none
        color #9d9d9d
    &.time-month
      width 350px
      margin 32px auto 22px
      .month-names
        display flex
        justify-content center
      .month-name
        font-size 16px
        width 100px
        text-align center
        display flex
        justify-content center
        white-space nowrap
        .name
          display inline-block
          // width 26px
          height 24px
          display flex
          align-items center
          color #4a4a4a
          padding-left 2px
          &.isAndroid
            padding-left 1px
        .active
          font-family PingFangSC-Medium, 'PingFangH'
          border-bottom 2px solid #000000
          color #000
      .line
        overflow hidden
        &.week-name
          margin 36px 0 12px
        &.line-day-box
          height 264px
        .box
          float left
          width 27px
          font-size 16px
          height 16px
          line-height 16px
          text-align center
          margin 0 11.5px
          &.day-number
            margin 14px 11.5px
            color #4a4a4a
            .number
              position relative
            .xing
              position absolute
              right -7px
              top 3px
              font-size 12px
          &.disabled
            pointer-events none
            color #dadada
          &.active
            color #fff
            position relative
            &::before
              content ''
              display block
              width 40px
              height 40px
              background #000000
              position absolute
              left -6.5px
              top -12px
              border-radius 50%
              z-index -1
          &.hidden
            opacity 0
            pointer-events none
  .button
    width 327px
    height 44px
    margin 0 auto
    background #000000
    color #ffffff
    text-align center
    line-height 44px
    font-size 14px
    &.disabled
      background #acacac
      pointer-events none
</style>
